// LocationAppRoutes.tsx
import React from 'react';
import { Route, Routes } from 'react-router-dom';
import PrivateRoute from '../../common/components/router/PrivateRoute';
import { PERMISSIONS } from '../../common/constants';
import Countries from '../../features/countries/Countries';
import Regions from '../../features/regions/Regions';
import Municipalities from '../../features/municipalities/Municipalities';
import Places from '../../features/places/Places';
import SkiResorts from '../../features/skiResorts/SkiResorts';
import SkiResortDetails from '../../features/skiResorts/SkiResortDetails';
import CountryDetails from '../../features/countries/CountryDetails';
import RegionDetails from '../../features/regions/RegionDetails';
import MunicipalityDetails from '../../features/municipalities/MunicipalityDetails';
import PlaceDetails from '../../features/places/PlaceDetails';
import NotFound from '../../common/components/router/NotFound';

const LocationAppRoutes = () => (
  <Routes>
    <Route
      path="/countries"
      element={
        <PrivateRoute permissions={[PERMISSIONS.LocationRead]}>
          <Countries />
        </PrivateRoute>
      }
    />
    <Route
      path="/countries/:countryId"
      element={
        <PrivateRoute
          permissions={[PERMISSIONS.LocationRead, PERMISSIONS.LocationModify]}
        >
          <CountryDetails />
        </PrivateRoute>
      }
    />
    <Route
      path="/countries/addnew"
      element={
        <PrivateRoute permissions={[PERMISSIONS.LocationModify]}>
          <CountryDetails />
        </PrivateRoute>
      }
    />
    <Route
      path="/regions"
      element={
        <PrivateRoute permissions={[PERMISSIONS.LocationRead]}>
          <Regions />
        </PrivateRoute>
      }
    />
    <Route
      path="/regions/:regionId"
      element={
        <PrivateRoute
          permissions={[PERMISSIONS.LocationRead, PERMISSIONS.LocationModify]}
        >
          <RegionDetails />
        </PrivateRoute>
      }
    />
    <Route
      path="/regions/addnew"
      element={
        <PrivateRoute permissions={[PERMISSIONS.LocationModify]}>
          <RegionDetails />
        </PrivateRoute>
      }
    />
    <Route
      path="/municipalities"
      element={
        <PrivateRoute permissions={[PERMISSIONS.LocationRead]}>
          <Municipalities />
        </PrivateRoute>
      }
    />
    <Route
      path="/municipalities/:municipalityId"
      element={
        <PrivateRoute
          permissions={[PERMISSIONS.LocationRead, PERMISSIONS.LocationModify]}
        >
          <MunicipalityDetails />
        </PrivateRoute>
      }
    />
    <Route
      path="/municipalities/addnew"
      element={
        <PrivateRoute permissions={[PERMISSIONS.LocationModify]}>
          <MunicipalityDetails />
        </PrivateRoute>
      }
    />
    <Route
      path="/places"
      element={
        <PrivateRoute permissions={[PERMISSIONS.LocationRead]}>
          <Places />
        </PrivateRoute>
      }
    />
    <Route
      path="/places/:placeId"
      element={
        <PrivateRoute
          permissions={[PERMISSIONS.LocationRead, PERMISSIONS.LocationModify]}
        >
          <PlaceDetails />
        </PrivateRoute>
      }
    />
    <Route
      path="/places/addnew"
      element={
        <PrivateRoute permissions={[PERMISSIONS.LocationModify]}>
          <PlaceDetails />
        </PrivateRoute>
      }
    />
    <Route
      path="/skiresorts"
      element={
        <PrivateRoute permissions={[PERMISSIONS.LocationRead]}>
          <SkiResorts />
        </PrivateRoute>
      }
    />
    <Route
      path="/skiresorts/:skiResortId"
      element={
        <PrivateRoute
          permissions={[PERMISSIONS.LocationRead, PERMISSIONS.LocationModify]}
        >
          <SkiResortDetails />
        </PrivateRoute>
      }
    />
    <Route
      path="/skiresorts/addnew"
      element={
        <PrivateRoute permissions={[PERMISSIONS.LocationModify]}>
          <SkiResortDetails />
        </PrivateRoute>
      }
    />
    <Route path="*" element={<NotFound />} />
  </Routes>
);

export default LocationAppRoutes;
